import { render, staticRenderFns } from "./ShareOnInstagram.vue?vue&type=template&id=1a5cd4ba&"
import script from "./ShareOnInstagram.vue?vue&type=script&lang=js&"
export * from "./ShareOnInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports